import { useRouteLoaderData } from "react-router-dom"
import AdminTournamentsShow from "../../components/admin/AdminTournamentsShow.jsx"
import { GetTournament } from "../../repo/TournamentsRepo.js";

export default function TournamentShowPage() {
  const response = useRouteLoaderData('admin-tournament')

  return(
    <section className="m-8">
      {response && (
        <AdminTournamentsShow tournament={response}/>
      )}
    </section>
  )
}

export async function loader({ params, request }) {
  return await GetTournament(params.id)
}
